/** YouTube / Vimeo thumbnail helpers for media kit intro reel. */

export function isVerticalIntroVideoUrl(url: string | null | undefined): boolean {
    if (!url?.trim()) {
        return false;
    }
    return /youtube\.com\/shorts\//i.test(url.trim());
}

function extractYoutubeId(url: string): string | null {
    const trimmed = url.trim();
    const youtuBeMatch = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (youtuBeMatch?.[1]) {
        return youtuBeMatch[1];
    }
    const watchMatch = trimmed.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (watchMatch?.[1]) {
        return watchMatch[1];
    }
    const shortsMatch = trimmed.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/i);
    if (shortsMatch?.[1]) {
        return shortsMatch[1];
    }
    const embedMatch = trimmed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/i);
    if (embedMatch?.[1]) {
        return embedMatch[1];
    }
    const liveMatch = trimmed.match(/youtube\.com\/live\/([a-zA-Z0-9_-]{11})/i);
    if (liveMatch?.[1]) {
        return liveMatch[1];
    }
    return null;
}

function extractVimeoId(url: string): string | null {
    const trimmed = url.trim();
    if (/^\d+$/.test(trimmed)) {
        return trimmed;
    }
    const match = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
    return match?.[1] ?? null;
}

export function getIntroVideoThumbnailFallbackUrl(url: string | null | undefined): string | null {
    if (!url?.trim()) {
        return null;
    }
    const youtubeId = extractYoutubeId(url);
    if (youtubeId) {
        return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
    }
    return null;
}

export function getIntroVideoThumbnailUrl(url: string | null | undefined): string | null {
    if (!url?.trim()) {
        return null;
    }
    const youtubeId = extractYoutubeId(url);
    if (youtubeId) {
        return `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
    }
    const vimeoId = extractVimeoId(url);
    if (vimeoId) {
        return `https://vumbnail.com/${vimeoId}.jpg`;
    }
    return null;
}
